import React from 'react';
import { Box, List, ListItem, ListItemButton, ListItemText, Typography } from '@mui/material';
import { CatalogFigure } from '../../models/MasterAssembly';

interface FigureListProps {
  figures: CatalogFigure[];
  onSelectFigure: (figure: CatalogFigure) => void;
}

const FigureList: React.FC<FigureListProps> = ({ figures, onSelectFigure }) => {
  const getDisplayFigureNumber = (fig: CatalogFigure, index: number) => {
    const rawFigureNumber = String(fig.figNumber || fig.figId || index + 1).trim();
    return rawFigureNumber.replace(/^(figure|fig)\s*/i, '').trim() || String(index + 1);
  };

  return (
    <Box>
      <Typography variant="h6">Figure List</Typography>
      <List>
        {[...figures].sort((a, b) => a.figOrder - b.figOrder).map((fig, index) => {
          const figureNumber = getDisplayFigureNumber(fig, index);
          const figureTitle = String(fig.figTitle || '').trim();
          return (
            <ListItem key={fig.figId || fig.figNumber} disablePadding>
              <ListItemButton onClick={() => onSelectFigure(fig)}>
                <ListItemText primary={`${figureNumber}. ${figureTitle || `Figure ${figureNumber}`}`} />
              </ListItemButton>
            </ListItem>
          );
        })}
      </List>
    </Box>
  );
};

export default FigureList;
